/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MenuNonOrdinarioForm } from './menu-non-ordinario-form';
import { CategoriaDipendenteMensa } from './categoria-dipendente-mensa';


export interface CategoriaForm { 
    categoria: CategoriaDipendenteMensa;
    numero_pasti_ordinari?: number;
    note?: string;
    menu_non_ordinari?: Array<MenuNonOrdinarioForm>;
}



